import { Box, Card, Divider, DropdownSelect, IconButton, Text, Tooltip } from '@zillow/constellation-10';
import { IconInfoFilled } from '@zillow/constellation-icons';

import { useAutoSpotlight } from './AutoSpotlightContext';
import { OPTIMIZER_LIST } from './rabDeployment';
import { SPOTLIGHT_COPY as COPY } from './spotlightCopy';

import type { OptimizerId } from './rabDeployment';

const INFO_ICON = (
  <IconButton
    title="Info"
    size="sm"
    emphasis="bare"
    shape="circle"
    css={{ color: 'icon.muted', width: 'icon.sm', height: 'icon.sm' }}
    icon={<IconInfoFilled />}
  />
);

export function OptimizeForScopeCard() {
  const ctx = useAutoSpotlight();
  if (!ctx) {
    return null;
  }

  const options = OPTIMIZER_LIST.map((o) => ({ label: o.label, value: o.id, meta: o.description }));

  return (
    <Card css={{ marginBlock: '400', padding: '500' }}>
      <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box css={{ display: 'flex', alignItems: 'center', gap: '200' }}>
          <Text textStyle="heading-sm">Spotlight</Text>
          <Tooltip content={COPY.exposureCopy} trigger={INFO_ICON} />
        </Box>
        <Box css={{ display: 'flex', alignItems: 'center', gap: '200' }}>
          <Text textStyle="body-sm">
            {ctx.availableCount} Available spot{ctx.availableCount === 1 ? '' : 's'} • {ctx.pinnedCount} Pinned ·{' '}
            {ctx.autoCount} Auto deployed
          </Text>
          <Tooltip content={COPY.tooltips.summaryCounts} trigger={INFO_ICON} />
        </Box>
      </Box>

      <Divider css={{ marginBlock: '400' }} />

      <Box css={{ display: 'flex', alignItems: 'center', gap: '300' }}>
        <Tooltip content={COPY.tooltips.optimizeBy} trigger={INFO_ICON} />
        <Text textStyle="body-sm-bold" css={{ color: '{colors.text.interactive}' }}>
          Optimize by
        </Text>
        <DropdownSelect
          value={ctx.optimizer}
          options={options}
          onChange={(value) => ctx.onChangeOptimizer((Array.isArray(value) ? value[0] : value) as OptimizerId)}
          showLabelForValue
          size="sm"
          css={{ width: '220px' }}
        />
      </Box>
    </Card>
  );
}

export default OptimizeForScopeCard;
